/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.onSwatchChangeBound = this.onSwatchChange.bind(this);
    this.onSwatchClickBound = this.onSwatchClick.bind(this);
  }

  connectedCallback() {
    this.colorLabel = this.querySelector('[data-color-swatch-name]');
    this.colorLabelState = this.querySelector('[data-color-swatch-state]');
    this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
    this.sectionId = this.getAttribute('data-section-id');
    this.syncSelection();
    this.addEventListener('change', this.onSwatchChangeBound);
    this.addEventListener('click', this.onSwatchClickBound);
  }

  syncSelection() {
    this.selectedInput = this.querySelector('input[type="radio"]:checked');
    this.querySelectorAll('.swatch-element').forEach(swatch => {
      swatch.classList.toggle('active', !!swatch.querySelector('input:checked'));
      swatch.classList.remove('sibling-hover-active');
    });
    if (!this.selectedInput) return;

    // The caption always describes the checked option, including on touch devices.
    if (this.colorLabel) {
      const value = this.selectedInput.value;
      this.colorLabel.textContent = value.length > 22 ? value.slice(0, 19) + '...' : value;
    }
    if (this.colorLabelState) {
      const available = this.selectedInput.closest('.swatch-element')?.getAttribute('data-swatch-option-available');
      this.colorLabelState.textContent = available === 'false' && this.soldOutString ? '(' + this.soldOutString + ')' : '';
    }
  }

  onSwatchChange(event) {
    const input = event.target;
    if (!input.matches('input[type="radio"]')) return;
    this.syncSelection();
    eventBus.emit('variant:change', {
      sectionId: this.sectionId,
      variant: this.getVariantData(input.id),
      fetchURL: input.getAttribute('data-product-fetch-url'),
      productURL: input.getAttribute('data-product-url'),
      isCombinedListing: input.getAttribute('data-is-combined-listing') === 'true'
    });
  }

  onSwatchClick(event) {
    // A radio's click runs before change. Only the previously chosen radio is a reselect.
    const input = event.target;
    if (input !== this.selectedInput || !input.checked) return;
    this.syncSelection();
    eventBus.emit('variant:reselect', {
      sectionId: this.sectionId,
      variant: this.getVariantData(input.id)
    });
  }

  getVariantData(inputId) {
    const element = this.querySelector('script[type="application/json"][data-resource="' + inputId + '"]');
    return element ? JSON.parse(element.textContent) : null;
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onSwatchChangeBound);
    this.removeEventListener('click', this.onSwatchClickBound);
  }
}

if (!customElements.get('product-swatch')) {
  customElements.define('product-swatch', ProductSwatch);
}
/******/ })()
;
